import reducer from "./reducers";

import * as phaseAction from "./actions";

export { phaseAction };

export default reducer;
